import { __awaiter } from "tslib";
import { callService, loadWebtexte } from "@phoenixreisen/gateway";
import fields from "./components/formular/form.model.fields";
import m from "mithril";
export const Model = {
    webtexte: null,
    catalog: undefined,
    nations: { all: [], fav: [] },
    splitStreetAndHouseNumber(fullAddress) {
        if (!fullAddress)
            return { street: "", houseNumber: "" };
        const match = fullAddress.match(/^(.+?)\s+(\d+[a-zA-Z]?)(\s.*)?$/);
        if (match) {
            return {
                street: match[1].trim(),
                houseNumber: match[2],
            };
        }
        return { street: fullAddress, houseNumber: "" };
    },
    prefillAddressFormWith(customer) {
        const { address } = fields;
        const { street, houseNumber } = this.splitStreetAndHouseNumber(customer["kundendaten/strasse"]);
        address.city.validate(customer["kundendaten/ort"]);
        address.zipCode.validate(customer["kundendaten/plz"]);
        address.gender.validate(customer["kundendaten/anrede"]);
        address.street.validate(street);
        address.houseNumber.validate(houseNumber);
        address.prename.validate(customer["kundendaten/vorname"]);
        address.surname.validate(customer["kundendaten/nachname"]);
        address.country.validate(customer["kundendaten/laenderkennung"]);
    },
    resetFields() {
        const { address, customer } = fields;
        customer.zip.value("");
        customer.number.value("");
        address.gender.value("");
        address.prename.value("");
        address.surname.value("");
        address.street.value("");
        address.houseNumber.value("");
        address.zipCode.value("");
        address.city.value("");
        address.country.value("");
        address.addressAddition.value("");
    },
    getWebtexte() {
        return __awaiter(this, void 0, void 0, function* () {
            const categories = [
                "katalogbestellung__erfolg",
                "katalogbestellung__ueberschrift",
                "katalogbestellung__newsletter_link",
                "katalogbestellung__newsletter_teaser",
                "katalogbestellung__kunde_nicht_gefunden",
            ];
            if (this.webtexte) {
                return Promise.resolve(this.webtexte);
            }
            return loadWebtexte(categories, "webtexte.katalogbestellung").then((result) => {
                this.webtexte = result;
                m.redraw();
                return result;
            });
        });
    },
    getCatalog(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return callService("katalog.katalogbestellung-config", {
                type: "get-katalogbestellung-config",
                "katalog-kennung": id,
            }).then((result) => {
                if (result["bestellungconfig"]) {
                    return result["bestellungconfig"];
                }
                throw result;
            });
        });
    },
    save(address, customer) {
        return __awaiter(this, void 0, void 0, function* () {
            return callService("katalog.katalogbestellung-speichern", {
                type: "katalogbestellung-speichern",
                "remote-addr": "set by backend",
                katalogbestellung: {
                    "bestellung/ort": address.city.value(),
                    "bestellung/anrede": address.gender.value(),
                    "bestellung/strasse": address.street.value(),
                    "bestellung/haus-nr": address.houseNumber.value(),
                    "bestellung/vorname": address.prename.value(),
                    "bestellung/landcode": address.country.value(),
                    "bestellung/nachname": address.surname.value(),
                    "bestellung/katalog-kennung": m.route.param("key"),
                    "bestellung/akademischer-titel": address.title.value(),
                    "bestellung/adresszusatz": address.addressAddition.value(),
                    "bestellung/kunden-nr": parseInt(customer.number.value(), 10),
                    "bestellung/plz": address.zipCode.value().toString(),
                },
            });
        });
    },
};
export default Model;
